import { put, select, takeLatest } from 'redux-saga/effects'
import { getSignersSelector } from '../selectors'
import { setSignerList } from '../store/completeChart.actions'
import { CompleteChartConstants } from '../store/completeChart.constants'
import { ISignerState } from '../store/completeChart.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* setExtraSecurityId() {
  const signerState: ISignerState = yield select(getSignersSelector)
  const { extraSecurityId, signer, signerList } = signerState
  const selectedPin = signerList.filter((u) => u.key === signer?.key)
  if (selectedPin && selectedPin.length) {
    selectedPin[0].extraSecurityId = extraSecurityId
    yield put(setSignerList(signerList))
  }
}
export function* setExtraSecurityIdSaga() {
  yield takeLatest([CompleteChartConstants.SET_EXTRA_SECURITY_ID], performWithMutexHOG, setExtraSecurityId)
}
